define(["./nodeCommandsModule"], function (nodeCommandModule) {
    "use strict";

    return nodeCommandModule.service("nodeCommandViewArrangement", ["arrangementViewerModal", function (arrangementViewerModal) {
        return function (selection) {
            return arrangementViewerModal.forLoad(selection[0].id);
        };
    }]);
});